import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmModalResult, ConfirmModalStatus } from '../models/confirm-modal';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {
  public static readonly DEFAULT_NAME = 'confirm-modal';

  private status = new Subject<ConfirmModalStatus>();
  private result = new Subject<ConfirmModalResult>();

  constructor() { }

  confirm(name: string = null) {
    // Set default name in case it's not set
    if (!name) {
      name = ConfirmModalService.DEFAULT_NAME;
    }

    this.status.next({ name, show: true });
    return new Promise((resolve, reject) => {
      const subscription = this.result.subscribe(val => {
        subscription.unsubscribe();
        this.status.next({ name, show: false });
        if (val?.result) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  update(name: string, result: boolean) {
    this.result.next({ name, result });
  }

  get statusChanges() {
    return this.status.asObservable();
  }

  get resultChanges() {
    return this.result.asObservable();
  }
}
